import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    position: 'relative',
  },
  containerCards: {
    display: 'flex',
    flexDirection: 'column',
    width: '60%',
  },
  containerCard: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    [theme.breakpoints.down(830)]: {
      gridTemplateColumns: '1fr',
    },
  },
  containerCardLarge: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
  },
  sidebar: {
    paddingLeft: 16,
    width: '40%',
    position: 'absolute',
    right: 0,
  },
  helper: {
    marginTop: 16,
  },
  helperAgentName: {
    textTransform: 'capitalize',
  },
}))
